import { ApiResponse } from "../types/common";
import { SearchProductRequest, SearchProductResponse } from "../types/products";

import apiClient from "./apiClient";

export const searchProduct = (
  data: SearchProductRequest,
): Promise<ApiResponse<SearchProductResponse>> => {
  return apiClient
    .get("/Products/search", { params: data })
    .then((response) => response.data);
};
